import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.GET_CATEGORIES,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/getCategories.js